<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="titlepage">
<h1 class="title">THE<br/>COLOUR<br/>OF<br/>THUNDER</h1>
<p class="author">SUZANNE HARRISON</p>
<p class="imagea"><img alt="Illustration" src="images/f0001-01.png"/></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?cdcfd730